/**
 * Which conversation's thread is actually mounted on screen right now.
 *
 * Module-level rather than a Zustand field: the one writer (`ConversationPanel`)
 * and the one reader (`useIncomingMessageAlerts`) never render in the same
 * subtree: the thread panel mounts only inside the Presence page's Chats tab,
 * while the alert hook is mounted once at the app shell (`DashboardLayout`) so
 * it keeps working on every other page too. A plain get/set plus a mount
 * effect on the panel is enough; nothing here needs to be reactive since the
 * alert hook only reads it at the moment a message arrives.
 */

let activeConversationId: string | null = null

/** Call on mount with the conversation id, and on unmount with `null` (but
 *  only if this caller still owns the slot; see the guard in the panel). */
export function setActiveConversationId(id: string | null): void {
  activeConversationId = id
}

export function getActiveConversationId(): string | null {
  return activeConversationId
}
